import { inject, Injectable, Provider } from '@angular/core';
import { LazyInject } from '@rma/generic/util/lazy-inject';
import { ShortlistMergePrompt } from '@rma/public/compare-agent/private-api/da-compare-agent';
import { from, Observable, switchMap } from 'rxjs';
import type { ShortlistMergeModalData } from './shortlist-merge.facade';
import type { ShortlistMergeModalComponent } from './ui-shortlist-merge-modal/shortlist-merge-modal.component';

@Injectable()
export class ShortlistMergePromptService implements ShortlistMergePrompt {
  private readonly lazyInject = inject(LazyInject);

  public choose(localCodes: string[], apiCodes: string[]): Observable<string[] | undefined> {
    return from(
      Promise.all([
        // Injecting RmaModalService directly would put Material dialog in the bundle every page loads.
        this.lazyInject.get(() => import('@rma/public/generic/ui/modal').then((m) => m.RmaModalService)),
        import('./ui-shortlist-merge-modal/shortlist-merge-modal.component'),
      ]),
    ).pipe(
      switchMap(([modalService, { ShortlistMergeModalComponent: component }]) =>
        modalService
          .open<ShortlistMergeModalComponent, ShortlistMergeModalData, string[] | undefined>(component, {
            data: { localCodes, apiCodes },
            disableClose: true,
            maxWidth: '72rem',
            width: 'calc(100vw - 2rem)',
            ariaLabelledBy: 'rma-shortlist-merge-heading',
            autoFocus: 'dialog',
          })
          .afterClosed(),
      ),
    );
  }
}

export const provideShortlistMergePrompt = (): Provider => ({ provide: ShortlistMergePrompt, useClass: ShortlistMergePromptService });
